import type { PostLocale } from './posts'

export interface PostLocaleLabels {
  htmlLang: string
  ogLocale: string
  name: string
  tagline: string
  description: string
  home: string
  about: string
  all: string
  empty: string
  loadingMore: string
  back: string
  updated: string
  reviewedBy: string
  minRead: string
  postNotFound: string
  postInfo: string
  author: string
  date: string
  category: string
  tags: string
  onThisPage: string
  relatedPosts: string
  languages: string
  menu: string
  categories: string
  disclosure: string
  privacy: string
}

export const POST_LOCALE_LABELS: Record<PostLocale, PostLocaleLabels> = {
  en: {
    htmlLang: 'en', ogLocale: 'en_US', name: 'English', tagline: 'Caudex & Succulent Care',
    description: 'Science-based care guides for caudex and succulent plants — pachypodium, adenium, dioscorea, and more.',
    home: 'Home', about: 'About', all: 'All',
    empty: 'No posts in this category.', loadingMore: 'Loading more posts…', back: '← Back to Blog',
    updated: 'Updated', reviewedBy: 'Reviewed by', minRead: 'min read', postNotFound: 'Post not found.',
    postInfo: 'Post Info', author: 'Author', date: 'Date', category: 'Category', tags: 'Tags',
    onThisPage: 'On this page', relatedPosts: 'Related Posts', languages: 'Language', menu: 'Menu',
    categories: 'Categories', disclosure: 'Disclosure', privacy: 'Privacy',
  },
  fr: {
    htmlLang: 'fr', ogLocale: 'fr_FR', name: 'Français', tagline: 'Soins des caudex et des plantes succulentes',
    description: 'Guides de culture fondés sur la science pour les caudex et les plantes succulentes — pachypodiums, adéniums, dioscorées et bien plus.',
    home: 'Accueil', about: 'À propos', all: 'Tous',
    empty: 'Aucun article dans cette catégorie.', loadingMore: 'Chargement d’autres articles…', back: '← Retour au blog',
    updated: 'Mis à jour le', reviewedBy: 'Relu par', minRead: 'min de lecture', postNotFound: 'Article introuvable.',
    postInfo: 'Informations', author: 'Auteur', date: 'Date', category: 'Catégorie', tags: 'Mots-clés',
    onThisPage: 'Dans cet article', relatedPosts: 'Articles associés', languages: 'Langue', menu: 'Menu',
    categories: 'Catégories', disclosure: 'Divulgation', privacy: 'Confidentialité',
  },
  es: {
    htmlLang: 'es', ogLocale: 'es_ES', name: 'Español', tagline: 'Cuidados de caudex y suculentas',
    description: 'Guías de cuidados basadas en la ciencia para plantas caudiciformes y suculentas — pachypodium, adenium, dioscorea y más.',
    home: 'Inicio', about: 'Acerca de', all: 'Todos',
    empty: 'No hay artículos en esta categoría.', loadingMore: 'Cargando más artículos…', back: '← Volver al blog',
    updated: 'Actualizado el', reviewedBy: 'Revisado por', minRead: 'min de lectura', postNotFound: 'Artículo no encontrado.',
    postInfo: 'Información', author: 'Autor', date: 'Fecha', category: 'Categoría', tags: 'Etiquetas',
    onThisPage: 'En este artículo', relatedPosts: 'Artículos relacionados', languages: 'Idioma', menu: 'Menú',
    categories: 'Categorías', disclosure: 'Divulgación', privacy: 'Privacidad',
  },
}

export function postLocaleFromPath(pathname: string): PostLocale {
  const segment = pathname.split('/').filter(Boolean)[0]
  return segment === 'fr' || segment === 'es' ? segment : 'en'
}

export function localeRoot(locale: PostLocale): string {
  return locale === 'en' ? '/' : `/${locale}/`
}

export function localeCategoryRoute(locale: PostLocale, category: string): string {
  const prefix = locale === 'en' ? '' : `/${locale}`
  return `${prefix}/category/${category}/`.replace('//', '/')
}
